// extracted by mini-css-extract-plugin
module.exports = {"container":"BundleItemsMessage-module--container--218QG","wrapper":"BundleItemsMessage-module--wrapper--1F8cL"};